import React from 'react';
import { MainBgWrapper } from '../../../component/bgWrapper';
import IntroSection from '../../../component/introSection';
import LoginInput from './component/LoginInput';

const LoginPage:React.FC = () => (

  <MainBgWrapper>
    <IntroSection title="[로그인]" content="아직 아름다운 가능성으로 가득합니다. 시럽 인연과 함께 하세요." />
    <LoginInput />
  </MainBgWrapper>

);

export default LoginPage;
